import React, { FC, useState, useCallback } from 'react'
import { IPlayer, IMatch, MatchStatus } from 'protos'
import { makeStyles, ButtonBase, Box, Divider, Typography } from '@material-ui/core'
import FormattedMessage from 'components/FormattedMessage'
import orderBy from 'lodash-es/orderBy'
import FlatList from 'components/FlatList'
import PlayerListItem from './components/PlayerListItem'
import ascIcon from './assets/arrow-down.svg'
import descIcon from './assets/arrow-up.svg'

type Props = {
  match: IMatch
  availablePlayers: Array<IPlayer>
  selectedPlayerIds?: Array<IPlayer['playerId']>
  onTogglePlayer: (player: IPlayer) => void
  onRequestPlayerProfile: (player: IPlayer) => void
}

const useStyles = makeStyles({
  button: {
    flex: 1,
    height: 35,
    justifyContent: 'flex-start',
  },
  fontSize12: {
    fontSize: 12,
  },
})

type SortOption = {
  order: 'asc' | 'desc'
  field: 'name' | 'cost' | 'averageScore'
}

const sortOptions: SortOption[] = [
  {
    order: 'asc',
    field: 'name',
  },
  {
    order: 'desc',
    field: 'cost',
  },
  {
    order: 'desc',
    field: 'averageScore'
  }
]

const fieldTranslationMap = {
  name: 'teameditor_sort_name',
  cost: 'teameditor_sort_cost',
  averageScore: 'teameditor_sort_score',
}

const SortablePlayerList: FC<Props> = ({
  match, selectedPlayerIds = [], availablePlayers, onTogglePlayer, onRequestPlayerProfile
}) => {
  const classes = useStyles()
  const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0])

  const orderedPlayers = orderBy(
    availablePlayers,
    [
      'notPlaying',
      'status',
      selectedSortOption.field,
      player => match.status === MatchStatus.MS_UPCOMING
        ? player.averageScore
        : player.currentScore
    ],
    ['asc', 'asc', selectedSortOption.order, 'desc']
  )

  const toggleSortOption = useCallback(() => {
    setSelectedSortOption((prevOption) => {
      const prevIndex = sortOptions.indexOf(prevOption)
      const nextIndex = sortOptions[prevIndex + 1] ? prevIndex + 1 : 0

      return sortOptions[nextIndex]
    })
  }, [])

  return (
    <>
      <Box
        px={2.5}
        display="flex"
        bgcolor="grey.50"
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
      >
        <ButtonBase
          className={classes.button}
          onClick={toggleSortOption}
        >
          <Typography
            component="div"
            className={classes.fontSize12}
          >
            <FormattedMessage
              id={fieldTranslationMap[selectedSortOption.field]}
            />
          </Typography>
        </ButtonBase>
        {
          selectedSortOption.order === 'desc'
            ? <img src={descIcon} alt="" />
            : <img src={ascIcon} alt="" />
        }
      </Box>
      <Divider />
      <FlatList
        items={orderedPlayers}
        itemRenderer={(player: IPlayer, i) => (
          <PlayerListItem
            player={player}
            key={player.playerId || i}
            onJerseyClick={onRequestPlayerProfile}
            onClick={() => onTogglePlayer(player)}
            selected={selectedPlayerIds.indexOf(player.playerId) > -1}
          />
        )}
      />
    </>
  )
}

export default SortablePlayerList
try {
    // @ts-ignore
    SortablePlayerList.displayName = "SortablePlayerList";
    // @ts-ignore
    SortablePlayerList.__docgenInfo = { "description": "", "displayName": "SortablePlayerList", "props": { "match": { "defaultValue": null, "description": "", "name": "match", "required": true, "type": { "name": "any" } }, "availablePlayers": { "defaultValue": null, "description": "", "name": "availablePlayers", "required": true, "type": { "name": "any[]" } }, "selectedPlayerIds": { "defaultValue": { value: "[]" }, "description": "", "name": "selectedPlayerIds", "required": false, "type": { "name": "any[]" } }, "onTogglePlayer": { "defaultValue": null, "description": "", "name": "onTogglePlayer", "required": true, "type": { "name": "(player: any) => void" } }, "onRequestPlayerProfile": { "defaultValue": null, "description": "", "name": "onRequestPlayerProfile", "required": true, "type": { "name": "(player: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/SortablePlayerList/SortablePlayerList.tsx#SortablePlayerList"] = { docgenInfo: SortablePlayerList.__docgenInfo, name: "SortablePlayerList", path: "src/components/SortablePlayerList/SortablePlayerList.tsx#SortablePlayerList" };
}
catch (__react_docgen_typescript_loader_error) { }